import { render, staticRenderFns } from "./CpvSelector.vue?vue&type=template&id=639f947b&"
import script from "./CpvSelector.vue?vue&type=script&lang=js&"
export * from "./CpvSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports